export const ROOT = 'common/password';

export const FORGOT_PASSWORD_REQUEST = `${ROOT}/FORGOT_PASSWORD_REQUEST`;
export const FORGOT_PASSWORD_FAILURE = `${ROOT}/FORGOT_PASSWORD_FAILURE`;
export const FORGOT_PASSWORD_SUCCESS = `${ROOT}/FORGOT_PASSWORD_SUCCESS`;

export const RESET_PASSWORD_REQUEST = `${ROOT}/RESET_PASSWORD_REQUEST`;
export const RESET_PASSWORD_FAILURE = `${ROOT}/RESET_PASSWORD_FAILURE`;
export const RESET_PASSWORD_SUCCESS = `${ROOT}/RESET_PASSWORD_SUCCESS`;